import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import {
  getAppDotOrigin,
  getEffectiveUser,
  hasPublisherAccess,
  hasExploreAccess,
  hasExploreSpecsAccess,
  hasCaptureAccess,
  track,
} from '../../util'
import PlatformNavLink from './PlatformNavLink'

const origin = getAppDotOrigin()

const PlatformNav = ({ customNav, appId, isSidebarNav }) => {
  if (customNav) {
    return customNav()
  }

  const effectiveUser = getEffectiveUser()
  const tooltipPosition = isSidebarNav ? 'left' : 'bottom'
  const canAccessExploreSpecs = hasExploreSpecsAccess(effectiveUser)
  const canAccessSomeExplore =
    canAccessExploreSpecs || hasExploreAccess(effectiveUser)
  const exploreVersion = canAccessExploreSpecs ? 'explore-specs' : 'explore'

  return (
    <Fragment>
      <PlatformNavLink
        id="onboard"
        isAuthorized
        tooltipPosition={tooltipPosition}
      />
      <PlatformNavLink
        id="capture"
        isAuthorized={hasCaptureAccess(effectiveUser)}
        tooltipPosition={tooltipPosition}
      />
      <PlatformNavLink
        id="publish"
        isAuthorized={hasPublisherAccess(effectiveUser)}
        tooltipPosition={tooltipPosition}
      />
      <PlatformNavLink
        id="explore"
        href={
          /explore/.test(appId)
            ? `/${exploreVersion}`
            : `${origin}/${exploreVersion}`
        }
        isAuthorized={canAccessSomeExplore}
        tooltipPosition={tooltipPosition}
        onClickAppLink={e => {
          if (!canAccessSomeExplore) {
            e.preventDefault()
          }
          track({ event: 'appLinkClick', label: exploreVersion })
        }}
      />
    </Fragment>
  )
}

PlatformNav.propTypes = {
  customNav: PropTypes.func,
  appId: PropTypes.string.isRequired,
  isSidebarNav: PropTypes.bool,
}

export default PlatformNav



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/PlatformNav.js